<template>
  <div class="wrapper">
    <van-row class="bg">
      <van-row type="flex" justify="end">
      </van-row>
      <van-row class="balance">
        <van-row>当前余额(元)</van-row>
        <span><span class="i">￥</span>{{money}}</span>
      </van-row>
    </van-row>
    
    <van-row class="btn" type="flex"  align="center" v-if="sysValue==1">
      <span class="money">￥</span>
      <input type="text" placeholder="请输入充值金额" class="input" v-model="rechargemoney"  ref="input">
      <van-button type="default" :disabled="disabled" size="small" class="submit" @click.native="btn">充值</van-button>
    </van-row>

    <div class="titleMid"><span>账单明细</span></div>

    <div :class="sysValue==1?'mid':'mid2'">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" :finished-text="list.length?'没有更多了':''" @load="loadMore" :offset="20">
          <div class="no" v-if="list.length == 0">
            <div>暂无账单明细</div>
          </div>
          <van-row class="box" v-for="(item,index) in list" :key="index" type="flex" justify="space-between">
            <van-col>
              <van-row class="reason">{{item.opt_type=='11'?'购买商品':item.opt_type=='121'?'充值':item.opt_type=='122'?'提现到余额':item.opt_type=='124'?'礼品卡兑换':item.opt_type=='19'?'退款':item.opt_type=='9001'?'系统调整':item.opt_type=='123'?'运费险赔付':''}}</van-row>
              <van-row class="time">{{item.create_time}}</van-row>
              <van-row class="midText" v-if="item.opt_type=='9001'">调整原因:{{item.note||'无'}}</van-row>
              <van-row class="nbr" v-if="item.opt_type=='11'||item.opt_type=='19'||item.opt_type=='123'">{{item.opt_type=='11'?'订单编号:'+item.opt_nbr:'退款编号:'+item.opt_nbr}}</van-row>
          </van-col>
            
          <van-col class="right">
            <van-row class="black"  v-if="item.opt_type=='11'||item.amount_state=='1'||item.amount<0">-{{Math.abs(item.amount).toFixed(2)}}</van-row>
            <van-row class="red" v-else>+{{item.amount}}</van-row>
          </van-col>
          </van-row>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
  import {checkempty} from "./../../assets/js/tool"
  import weChatShareApi from "../../assets/js/weChatShare";
  
  export default {
    components: {},
    props: {},
    mixins: [weChatShareApi],
    data() {
      return {
        money: "0.00",
        rechargemoney: "",
        reg: /^(\d?)+(\.\d{0,2})?$/,
        disabled:false,
        toast:null,
        count:0,
        isLoading: false,
        loading: false,
        finished: false,
        list:"",
        pageIndex: 0,
        totalRows: 0,
        numPerPage: 10,
        sysValue:1
      }
    },
    watch: {
      rechargemoney(val, old) {
        if(!val){
          return
        }
        if (this.reg.exec(val)) {
          this.$refs.input.value = val
        } else {
          val = val.substring(0, val.length - 1)
          this.$refs.input.value = val
        }
        if (Number(val) > 10000) {
          val = 10000;
          this.$toast('一次性充值不能大于10000');
        }
        this.rechargemoney = val
      }
    },
    methods: {
      onRefresh() {
        this.pageIndex = 0;
        this.isLoading=true;
        this.finished = false;
        this.getData([]);
      },
      loadMore(){
        if(this.finished){
          return false
        }
        this.loading = true;
        this.pageIndex++
        this.getData(this.list);
      },
      btn() {
        this.disabled = true
        if (!checkempty(this.rechargemoney, '请输入充值金额')) {
          this.disabled = false
          return
        }
        if (this.rechargemoney == 0) {
          this.disabled = false
          this.$toast('充值金额不能为0')
          return
        }
        let that = this;
        this.$commonPost({
          'jydm': 'flow_10000',
          'flow_10000': {
            sub_flow: 'flow_30037',
            user_nbr: this.userInfo.nbr,
            amount: this.rechargemoney
          },
        }).then(resp => {
          that.rechargeNbr = resp.recharge_order_nbr
          that.readyPay(resp.recharge_order_nbr)
        }).catch( err => {
          this.disabled = false
          this.$toast({
            message: err.message,
            duration: 2000
          });
        })
      },
      readyPay(rechargeNbr){
        let that = this
        let openid = localStorage.getItem('openid') || '';
        this.$post('/api/recharge/readyPay',{
          userNbr: this.userInfo.nbr,
          orderNbr: rechargeNbr,
          paymentMethod: 'WECHATPUBLICPAY',
          openid: openid,
        }).then(res=>{
          if(res.code == '200'){
            let resp = res.object.resp
            if(resp.resp_code =='0' && resp.resp_result=='0'){
              that.callpay(resp.resp)
            }else{
              that.disabled = false
              this.$toast({
                message: resp.resp_msg,
                duration: 2000
              });
            }
          }else{
            that.disabled = false
            this.$toast({
              message: res.message,
              duration: 2000
            });
          }
        }).catch( err => {
          that.disabled = false
          this.$toast({
            message: '您现在的网络不稳定，请稍后再试',
            duration: 2000
          });
        })
      },
      callpay(weChatPayInfo){
        let that = this
        function jsApiCall() {
          WeixinJSBridge.invoke("getBrandWCPayRequest", {
            "appId":weChatPayInfo.appId,     //公众号名称，由商户传入
            "timeStamp":weChatPayInfo.timeStamp,         //时间戳，自1970年以来的秒数
            "nonceStr":weChatPayInfo.nonceStr, //随机串
            "package":'prepay_id=' + weChatPayInfo.prepayid,
            "signType":weChatPayInfo.signType,         //微信签名方式：
            "paySign":weChatPayInfo.sign //微信签名
          }, function (res) {
            that.disabled = false
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              that.rechargemoney = "";
              that.toast = that.$toast({
                type:'loading',
                message:'支付中...',
                mask:true,
                duration: 0,
              });
              that.checkPay()
            } else if (res.err_msg == "get_brand_wcpay_request:cancel" || res.err_msg == "get_brand_wcpay_request:fail") {
              that.$toast({
                message: '支付失败',
                duration: 2000
              });
            }
          });
        }
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              jsApiCall,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", jsApiCall);
            document.attachEvent("onWeixinJSBridgeReady", jsApiCall);
          }
        } else {
          jsApiCall();
        }
      },
      checkPay(){
        let that =this
        if(this.count>60){
          this.$toast({
            message: '支付失败',
            duration: 2000
          });
        }
        this.$post('/api/recharge/order/checkPaySuccess',{
          orderNbr: this.rechargeNbr,
        }).then(res=>{
          this.toast.clear()
          if(res.code == '200'){
            let resp = res.object.resp
            if(resp.resp_code =='0' && resp.resp_result=='0'){
              this.$toast({
                message: '支付成功',
                duration: 2000
              });
              this.count = 0;
              this.getMoney();
              this.getData([]);
            }else if(resp.resp_code =='0' && resp.resp_result=='2'){
              this.count++
              setTimeout(()=>{
                that.checkPay()
              },1000)
            }else{
              this.toast.clear()
              this.count = 0;
              this.$toast({
                message: '支付失败',
                duration: 2000
              });
            }
          }else{
            this.toast.clear()
            this.count = 0;
            this.$toast({
              message: '支付失败',
              duration: 2000
            });
          }
        }).catch( err => {
          toast.clear()
          this.count = 0;
          this.$toast({
            message: '支付失败',
            duration: 2000
          });
        })
      },
      getMoney() {
        this.$commonPost({
          'jydm': 'flow_10003',
          'flow_10003': {
            user_nbr: this.userInfo.nbr,
          }
        }).then(resp => {
          this.money = resp.balance
        }).catch( err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        })
      },
      getData(oldList) {
        this.loading = true; //手动控制上啦正在加载，防止多次请求
        this.$commonPost({
          'jydm': 'flow_60014',
          'flow_60014': {
            user_nbr: this.userInfo.nbr,
            page_index: this.pageIndex*this.numPerPage,
            num_per_page: this.numPerPage,
          }
        }).then(response => {
          let arr = [];
          if (response.record) {
            if (response.record.length > 0) {
              arr = response.record;
            } else {
              arr.push(response.record);
            }
          }
          this.list = oldList.concat(arr);
          this.loading = false;
          this.isLoading = false;
          if (arr.length < this.numPerPage) {
            this.finished = true;
          }
        }).catch( err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        })
        
        this.$commonPost({
        jydm: "flow_10056",
        flow_10056: {
          value: 1
        }
      })
        .then(response => {
          this.sysValue = response.sys_value;
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
        
      },
      initPage(){
        this.getMoney();
        this.getData([]);
        let option = {
          title: '有米@'+this.userInfo.name+'的店铺',
          desc: "欢迎光临我的店铺",
          link: location.origin + "/?supNbr=" + this.userInfo.nbr,
          images: this.userInfo.imgUrl,
        };
        this.weChatShare(option)
      }
    },
    created() {
      document.title = '我的余额';
      this.initPage()
    },
    mounted() {
    },
    destroyed() {
    }
  }
</script>
<style scoped lang='stylus'>
  .mid >>> .van-list{
    
  }
  .mid >>> .no{
    margin:0 auto 0;
    padding-top 0.5rem;
    text-align: center;
    font-size:.28rem;
    color:#999;
  }
  .mid2 >>> .no{
    margin:0 auto 0;
    padding-top 0.5rem;
    text-align: center;
    font-size:.28rem;
    color:#999;
  }
</style>
<style scoped lang='less'>
  .mid{
    position: fixed;
    top: 4.82rem;
    width: 100%;
    height: calc(100vh - 4.82rem);
    overflow-y: auto;
  }
  .mid2{
    position: fixed;
    top: 4.5rem;
    width: 100%;
    height: calc(100vh - 4.82rem);
    overflow-y: auto;
  }
  .titleMid{
    padding-left: 0.6rem;
    width: 100%;
    box-sizing:border-box;
    height: .88rem;
    margin-top: .4rem;
    position: relative;
    span{
      font-size: .6rem;
      font-weight: bold;
      position: absolute;
      top: 50%;
      transform: translateY(-50%) scale(0.5);
      height: 0.42rem;
      line-height: 0.42rem;
      transform-origin: 0;
    }
    &::before{
      content:'';
      width: .06rem;
      height: 0.3rem;
      background: #E52B25;
      position: absolute;
      left: .24rem;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .wrapper {
    width: 100%;
    background: #fff;
    min-height: 100vh;
    overflow: hidden;
  }
  .box:after {
    display: none;
  }
  
  .box {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    font-size: 0.28rem;
    color: #333333;
    width: 7.02rem;
    min-height: 1.28rem;
    padding: 0.22rem 0.24rem;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: 0 .04rem .08rem 0 rgba(0,0,0,0.08);
    border-radius: .1rem;
    margin: 0 auto 0.1rem;
    .midText{
      margin: .1rem 0;
      font-size: .24rem;
      font-weight: 500;
      color: #999;
      line-height: .33rem;
      width: 4.6rem;
      word-break:break-all;
    }
    .red {
      font-size: 0.4rem;
      color: #E52B25;
    }
    .black{
      font-size: 0.4rem;
      color: #333;
    }
    .time {
      font-size: 0.24rem;
      color: #999999;
      line-height: .33rem;
      margin-top: .1rem;
    }
    .right{
      display: flex;
      align-items: center;
    }
    .reason{
      font-size: .28rem;
      font-weight: bold;
      color: #333;
      line-height: .4rem;
    }
    .nbr{
      font-size: .2rem;
      color: #999;
      margin-top: .1rem;
      line-height: .28rem;
    }
  }

  .bg {
    height:3.1rem;
    background: #E52B25;
  .balance {
    color: #FFFFFF;
    padding-top: 0.56rem;
  .van-row {
    font-size: 0.28rem;
    font-weight: bold;
    box-sizing: border-box;
    width: 100%;
    padding-left: .24rem;
  }
  span {
    font-size: 0.7rem;
    font-weight: bold;
    margin-top: .38rem;
    display: inline-block;
    margin-left: .24rem;
  }
  .i{
    font-size: .3rem;
    margin-left: 0;
  }
  img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  }
  }
  
  .btn {
    display: flex;
    margin: -0.44rem auto 0;
    width: 7.02rem;
    height: .88rem;
    background: #ffffff;
    border-radius: 0.44rem;
    line-height: 1.2rem;
    text-align: center;
    font-size: 0.32rem;
    color: #333333;
    overflow: hidden;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    box-shadow: 0 .02rem .08rem 0 rgba(0,0,0,0.10);
    .money{
      font-size: 0.4rem;
      margin-left: 0.3rem;
      margin-right: 0.14rem;
      font-weight: 500;
      line-height: 0;
    }
   .input {
    height: 0.4rem;
    border: none;
    font-size: .3rem !important;
    color: #ccc;
    flex:1;
    line-height: 0.4rem;
    &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
      color: #ccc;
      font-size: .3rem;
      font-weight: 500;
		}
		&::-moz-placeholder { /* Firefox 19+ */
      color: #ccc;
      font-size: .3rem;
      font-weight: 500;
		}
		&:-ms-input-placeholder { /* IE 10+ */
     color: #ccc;
     font-size: .3rem;
     font-weight: 500;
		}
		&:-moz-placeholder { /* Firefox 18- */
     color: #ccc;
     font-size: .3rem;
     font-weight: 500;
		}
   }
  .submit{
     background: #E52B25;
     box-shadow: 0 .02rem .06rem 0 rgba(0,0,0,0.10);
     border-radius: 0 .44rem .44rem 0;
     color: #fff;
     height: 110%;
     width: 1.54rem;
     font-size: 0.3rem;
     font-weight: bold;
     border:0;
   }
  }
  
  .van-button {
    color: #E52B25;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/information/recharge.vue